import {getTranslation} from "../translations/translationUtils";

export function createSubtitle(schedule) {
    let text = "";
    if (schedule.arrives) {
        text = text + schedule.arrives.defaultValue;
    }
    if (schedule.arrives.defaultValue || schedule.departs.defaultValue) {
        text = text + " - ";
    }
    if (schedule.departs) {
        text = text + schedule.departs.defaultValue;
    }
    return text;
}

export function createTranslatedSubtitle(schedule) {
    let text = getTranslation(schedule.arrives);
    if (getTranslation(schedule.arrives) || getTranslation(schedule.departs)) {
        text = text + " - ";
    }
    text = text + getTranslation(schedule.departs);
    return text;
}